import { render, staticRenderFns } from "./subAccordion.vue?vue&type=template&id=5fc7fcf0&scoped=true"
import script from "./subAccordion.vue?vue&type=script&lang=js"
export * from "./subAccordion.vue?vue&type=script&lang=js"
import style0 from "./subAccordion.vue?vue&type=style&index=0&id=5fc7fcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7fcf0",
  null
  
)

export default component.exports